import services from "@/http";
import * as types from "./mutation-types";

export const ActionShow = async ({ commit }) => {
  commit(types.SET_ISLOADING, true);
  try {
    const { data } = await services.assinaturas.get_configs();
    commit(types.SET_CONFIGURACOES, data);
  } finally {
    commit(types.SET_ISLOADING, false);
  }
};

export const ActionSave = async ({ commit }, payload) => {
  commit(types.SET_ISLOADING, true);
  try {
    const { data } = await services.assinaturas.put_configs(payload);
    commit(types.SET_CONFIGURACOES, data);
  } finally {
    commit(types.SET_ISLOADING, false);
  }
};

export const ActionSetConfiguracoes = ({ commit }, payload) => {
  commit(types.SET_CONFIGURACOES, payload);
};
